export const DEFAULT_ERROR: string = 'Something went wrong';
